export default {
  dev: {
    host: "https://uomsit.midea.com/uom-4a/midea-uom-gateway/uom-server/",
    mapnew5: 'https://mapnew5sit.midea.com/',
    mapHost: 'https://mapnew5sit.midea.com/',
    _4aPCUrl: 'https://mapnew5sit.midea.com/appdownload/pcv5-4a.html', // 测试
    _feedback: 'https://mapeconsolesit.midea.com/feedback/index.html', //意见反馈
    _guideZh: 'https://doc.midea.com/teamKnowledge/detail/docOnline/1999293397846560770?id=1999293397846560770&mc_widget_identifier=com.midea.kmp.teamknowledge', //操作指引（中文）
    _guideEn: 'https://doc.midea.com/teamKnowledge/detail/docOnline/2072864134161207297?id=2072864134161207297&mc_widget_identifier=com.midea.kmp.teamknowledge', //操作指引（英文）
    '_problem-zh': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=zh', // 常见问题
    '_problem-en': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    '_problem-ja': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    _4aUrl: 'https://signinuat.midea.com/login?service=',   // 测试
    defaultMobileUrl: 'https://mapnew5sit.midea.com/appdownload/pcv5.html',
    hormonyOSDownloadUrl: 'https://mapnew5sit.midea.com/mobile-h5-appupdatepage/index.html?appKey=e21c13e0-b57a-49f1-985b-01af30232e1a',
  },
  sit: {
    host: "https://uomsit.midea.com/midea-uom-gateway/uom-server/",
    mapnew5: 'https://mapnew5sit.midea.com/',
    mapHost: 'https://mapisit.midea.com/mtp/umeet/',
    _4aPCUrl: 'https://mapeconsolesit.midea.com/appdownload/pcv5-4a.html', // 测试
    _feedback: 'https://mapeconsolesit.midea.com/feedback/index.html', //意见反馈
    _guideZh: 'https://doc.midea.com/teamKnowledge/detail/docOnline/1999293397846560770?id=1999293397846560770&mc_widget_identifier=com.midea.kmp.teamknowledge', //操作指引（中文）
    _guideEn: 'https://doc.midea.com/teamKnowledge/detail/docOnline/2072864134161207297?id=2072864134161207297&mc_widget_identifier=com.midea.kmp.teamknowledge', //操作指引（英文）
    '_problem-zh': 'https://guide.midea.com/helpCenter/deta il?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=zh', // 常见问题
    '_problem-en': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    '_problem-ja': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    _4aUrl: 'https://signinuat.midea.com/login?service=',   // 测试
    defaultMobileUrl: 'https://mapeconsolesit.midea.com/appdownload/pcv5.html',
    hormonyOSDownloadUrl: 'https://mapnew5sit.midea.com/mobile-h5-appupdatepage/index.html?appKey=e21c13e0-b57a-49f1-985b-01af30232e1a',
  },
  uat: {
    host: "https://uomsit.midea.com/midea-uom-gateway/uom-server/",
    hormonyOSDownloadUrl: 'https://mapnew5sit.midea.com/mobile-h5-appupdatepage/index.html?appKey=e21c13e0-b57a-49f1-985b-01af30232e1a',
  },
  prod: {
    host: "https://uom.midea.com/midea-uom-gateway/uom-server/",
    mapnew5: 'https://mapnew5.midea.com/',
    mapHost: 'https://mapi.midea.com/mtp/umeet/',
    _4aPCUrl: 'https://im.midea.com/download/pcv5-4a.html',  // 生产
    _feedback: 'https://mapnew5.midea.com/feedback/index.html', //意见反馈(生产环境)
    _guideZh: 'https://doc.midea.com/teamKnowledge/detail/docOnline/1999293397846560770?id=1999293397846560770&mc_widget_identifier=com.midea.kmp.teamknowledge', //操作指引（中文）
    _guideEn: 'https://doc.midea.com/teamKnowledge/detail/docOnline/2072864134161207297?id=2072864134161207297&mc_widget_identifier=com.midea.kmp.teamknowledge', //操作指引（英文）
    '_problem-zh': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=zh', // 常见问题
    '_problem-en': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    '_problem-ja': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    _4aUrl: 'https://signin.midea.com/login?service=',
    defaultMobileUrl: 'https://im.midea.com/download/pcv5.html',
    hormonyOSDownloadUrl: 'https://mapnew5.midea.com/mobile-h5-appupdatepage/index.html?appKey=58031799-ea11-4bb7-b3db-68a9b438766c',
  },
  apis: [
    {
      // PC端获取下载地址
      name: "getPcUrl",
      config: {
        url: "api/sysParam/list/new/MeiXin_downloadPage_Link",
        // url: "api/sysParam/list/MeiXin_downloadPage_Link",
        method: "get",
      },
    },
    {
      name: "getMobileUrl",
      config: {
        url: "api/sysParam/listPost/MeiXin_downloadPage_Link",
        method: "post",
      },
    },
    {
      name: "getVPNUrl",
      config: {
        url: "api/sysParam/list/new/VPN_downloadPage_Link",
        method: "get",
      },
    },
    {
      name: "getMxVPNUrl",
      config: {
        url: "api/sysParam/list/VPN_downloadPage_Link",
        method: "get",
      },
    },
    {
      name: "ipInfo",
      config: {
        url: "url_preview/ip/info",
        method: "get",
        customHeaders: true,
        timeout: 5000,
      },
    },
  ]
};